import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { FooterComponent } from './footer.component';

@NgModule({
  declarations: [],
  imports: [FooterComponent, CommonModule, NzLayoutModule],
  exports: [FooterComponent],
})
export class FooterModule {}
